import api from '../../../services/api';
import {
  evalExport, evalGet, evalParams, listOf,
} from '../../../components/performance/evaluation/evaluationAnalytics';

// PM Analitik P4 — E06 Değerlendirme Farkları ve 360 Sonuçları (/performance/review-gaps) veri katmanı.
//   GET v1/performance-evaluation-analytics/review-gaps/summary          (M18 yönetici − öz, M19, M20, M21 + yön dağılımı, δ, T)
//   GET …/review-gaps/scatter                                             (öz × yönetici kovaları — 0,25 adım; kişi değil kova)
//   GET …/review-gaps/rater-profile                                       (yetkinlik × değerlendirici grubu; anonim grup a eşiği)
//   GET …/review-gaps/anonymous-groups                                    (anonim grup paneli: yalnız sayı ve eşiği geçen ortalama)
//   GET …/review-gaps/employees?sort=employee|gap&selfBin&managerBin      (+ export=xlsx; değerlendirici kimliği YOK)
//   GET …/review-gaps/findings
//   POST v1/performance-actions                                           (İK: beklenti görüşmesi aksiyonu — mevcut aksiyon akışı)

export const NS = 'performance.reviewGaps';

export const Q = {
  competency: 'dim',
  directions: 'dir',
  bands: 'rband',
  coverages: 'cov',
  groups: 'rgroup',
  selfBin: 'sbin',
  managerBin: 'mbin',
};
export const SCREEN_KEYS = Object.values(Q);

export const DIRECTIONS = ['close', 'managerHigher', 'selfHigher'];
export const GAP_BANDS = ['large', 'moderate', 'close'];
export const COVERAGES = ['complete', 'partial', 'none'];
export const RATER_GROUPS = ['self', 'manager', 'peer', 'subordinate', 'senior'];
export const ANONYMOUS_GROUPS = ['peer', 'subordinate', 'senior'];
export const BIN = 0.25;

/** URL değerleri → uç süzgeçleri (kova süzgeci yalnız çalışan listesine gider). */
export function screenFilters(values) {
  return {
    'competencyId[eq]': values[Q.competency] || null,
    'direction[in]': listOf(values[Q.directions]),
    'gapBand[in]': listOf(values[Q.bands]),
    'coverage[in]': listOf(values[Q.coverages]),
    'raterGroup[in]': listOf(values[Q.groups]),
  };
}

export const binFilters = (values) => (values[Q.selfBin] && values[Q.managerBin]
  ? { selfBin: values[Q.selfBin], managerBin: values[Q.managerBin] } : {});

export const fetchSummary = (filters, screen) => evalGet('review-gaps/summary', evalParams(filters, screen));
export const fetchScatter = (filters, screen) => evalGet('review-gaps/scatter', evalParams(filters, screen));
export const fetchRaterProfile = (filters, screen) => evalGet('review-gaps/rater-profile', evalParams(filters, screen));
export const fetchAnonymousGroups = (filters, screen) => evalGet('review-gaps/anonymous-groups', evalParams(filters, screen));
export const fetchFindings = (filters, screen) => evalGet('review-gaps/findings', evalParams(filters, screen));

const employeeParams = (filters, screen, bins, {
  sort, order, pageNumber, pageSize,
} = {}) => ({
  ...evalParams(filters, { ...screen, ...bins }),
  ...(sort ? { sort, order: order || 'asc' } : {}),
  ...(pageNumber ? { pageNumber, pageSize } : {}),
});

export const fetchEmployees = (filters, screen, bins, options) => evalGet('review-gaps/employees', employeeParams(filters, screen, bins, options));
export const exportEmployees = (filters, screen, bins, options) => evalExport('review-gaps/employees', employeeParams(filters, screen, bins, { ...options, pageNumber: null }));

/** İK: beklenti görüşmesi aksiyonu (mevcut PM aksiyon akışı; çalışan bağlantılı). Bildirim/hata Axios interceptor'ında. */
export async function createAction(payload) {
  try {
    const res = await api.post('/v1/performance-actions', payload);
    return !!res?.data?.status;
  } catch {
    return false;
  }
}
